import { generateIcon } from "./generateIcon"

/** @deprecated */
export const icons = {
  sortUnSort: generateIcon({ icon: "unsorted" }),
  sortAscending: generateIcon({ icon: "sort-asc" }),
  sortDescending: generateIcon({ icon: "sort-desc" }),
  menu: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#ffff" viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"></path></svg>`,
  filter: generateIcon({ icon: "filter" }),
  clipboardCut: generateIcon({ icon: "cut" }),
  clipboardCopy: generateIcon({ icon: "copy" }),
  clipboardPaste: generateIcon({ icon: "paste" }),
  save: generateIcon({ icon: "download" }),
  groupExpanded: generateIcon({
    icon: "arrow-down",
    width: 12,
    height: 8,
  }),
  groupContracted: generateIcon({ icon: "arrow-right" }),
  smallRight: generateIcon({ icon: "arrow-right" }),
  check: generateIcon({ icon: "check" }),
  csvExport: generateIcon({ icon: "save" }),
  excelExport: generateIcon({ icon: "save" }),
  groupLoading: generateIcon({ icon: "loader" }),
  smallDown: generateIcon({ icon: "arrow-down", width: 12, height: 8 }),
}

/** @deprecated */
export function generateSprite() {
  const sprite = document.createElementNS("http://www.w3.org/2000/svg", "svg")
  sprite.id = "datatable-sprite"
  Object.assign(sprite.style, {
    display: "none",
  })
  sprite.innerHTML = `
    <defs>
      <symbol id="unsorted" viewBox="0 0 12 12">
        <path d="M4 6.75L6.25 9L8.5 6.75" className="stroke-neutral-500" strokeWidth="0.75"></path>
        <path d="M4 4.25L6.25 2L8.5 4.25" className="stroke-neutral-500" strokeWidth="0.75"></path>
      </symbol>
      <symbol id="sort-asc" viewBox="0 0 12 12">
        <path d="M4 4.25L6.25 2L8.5 4.25" className="stroke-emerald-600" stroke-width="0.75"/>
      </symbol>
      <symbol id="sort-desc" viewBox="0 0 12 12">
        <path d="M4 6.75L6.25 9L8.5 6.75" className="stroke-emerald-600" stroke-width="0.75"/>
      </symbol>
      <symbol viewBox="0 0 12 13" id="menu">
        <path
          d="M.01 1.757h11.385M.01 10.329h11.385M0 6.041h8.597"
          stroke="currentColor"
        ></path>
      </symbol>
      <symbol
        id="filter"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        className="feather feather-filter"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
      </symbol>
      <symbol id="download" viewBox="0 0 12 12">
        <path
          stroke="#B7B7B9"
          strokeMiterlimit="10"
          d="M2 11.5h8M6 9.02V0M3 6.03l3 3L9.01 6"
        ></path>
      </symbol>
      <symbol id="arrow-right" viewBox="0 0 4 6">
        <path d="M1 5L3 3L1 1" stroke="#BFBFBF" />
      </symbol>
      <symbol id="arrow-down" viewBox="0 0 4 6">
        <path d="M1 1L3 3L5 1" stroke="currentColor" />
      </symbol>
      <symbol id="check" viewBox="0 0 14 11" color="#00CF9D">
        <path
          d="M1 4.2 5.5 9 13 1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </symbol>
      <symbol id="external" viewBox="0 0 8 8">
        <path d="M7.667.333L.236 7.764M.663.334h7.004V7.34" stroke="currentColor"/>
      </symbol>
      <symbol id="loader" viewBox="0 0 100 100">
        <path fill="none" stroke="currentColor" stroke-width="12" d="M50 15a35 35 0 1 0 24.749 10.251" transform-origin="center" />
        <path fill="currentColor" d="M49 3v24l12-12L49 3" transform-origin="center" />
      </symbol>
      <symbol id="search" viewBox="0 0 17 17" color="#B7B7B9" fill="none">
        <path d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16L12 12" stroke="currentColor" strokeWidth="1.5" />
      </symbol>
    <symbol id="cut" viewBox="0 0 256 256" fill="currentColor">
      <path d="M157.73,113.13A8,8,0,0,1,159.82,102L227.48,55.7a8,8,0,0,1,9,13.21l-67.67,46.3a7.92,7.92,0,0,1-4.51,1.4A8,8,0,0,1,157.73,113.13Zm80.87,85.09a8,8,0,0,1-11.12,2.08L136,137.7,93.49,166.78a36,36,0,1,1-9-13.19L121.83,128,84.44,102.41a35.86,35.86,0,1,1,9-13.19l143,97.87A8,8,0,0,1,238.6,198.22ZM80,180a20,20,0,1,0-5.86,14.14A19.85,19.85,0,0,0,80,180ZM74.14,90.13a20,20,0,1,0-28.28,0A19.85,19.85,0,0,0,74.14,90.13Z" />
    </symbol>
    <symbol id="copy" viewBox="0 0 256 256" fill="currentColor">
      <path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" />
    </symbol>
    </defs>
  `
  return sprite
}
